(() => {
  const isPhotoEvent = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return false;
    if (target.closest('img, picture')) return true;

    const container = target.closest('a, .product-media, .product-media-container, .mp-viewer__stage');
    if (!container) return false;

    return Array.from(container.querySelectorAll('img')).some((image) => {
      const bounds = image.getBoundingClientRect();
      return bounds.width > 0 && bounds.height > 0
        && event.clientX >= bounds.left && event.clientX <= bounds.right
        && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
    });
  };

  const preventPhotoSave = (event) => {
    if (isPhotoEvent(event)) event.preventDefault();
  };

  document.addEventListener('contextmenu', preventPhotoSave, true);
  document.addEventListener('dragstart', preventPhotoSave, true);
})();
